import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import ResetPasswordMutation from './AuthResetPasswordMutation';

const ResetPasswordConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(ResetPasswordMutation);

  const createResetPassword = async (request) => {
    const variables = request;

    const response = await mutate({
      variables,
    });

    return response;
  };

  return children({
    resetPassword: createResetPassword,
    loading,
  });
};

ResetPasswordConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ResetPasswordConnectorApollo;
